import React from 'react';
import { CategoryTags, TopicTags } from '../Articles/types/Article.types';

type TagProps = {
  tags: CategoryTags[] | TopicTags[];
};

const Tags: React.FC<TagProps> = ({ tags }) => {
  return (
    <>
      {tags.map(tag => (
        <React.Fragment key={tag.name}>
          <span> | </span>
          <p>{tag.displayName || tag.name}</p>
        </React.Fragment>
      ))}
    </>
  );
};

export default Tags;
